import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=70994933&scoped=true"
import script from "@/views/Users/Trainer/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Trainer/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Trainer/create-dialog.scss?vue&type=style&index=0&id=70994933&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70994933",
  null
  
)

export default component.exports